import * as Sentry from '@sentry/browser'

import { formatE164PhoneNumber, stringToSHA256Hash } from '@taxfix/scouts-helpers'

export const getHashedTrackingData = async (params: { phoneNumber?: string; email?: string }) => {
    try {
        return {
            hashedPhoneNumber: await stringToSHA256Hash(formatE164PhoneNumber(params.phoneNumber ?? '')),
            hashedEmail: await stringToSHA256Hash(params.email ?? ''),
        }
    } catch (error) {
        Sentry.captureException(error)
        return {}
    }
}
